import queryString from 'query-string';

import { createAxiosInstance } from '~/plugins/axios.plugin';

export class TagsService {
  static SERVICE_NAME = 'tags';

  constructor() {
    this.client = createAxiosInstance({
      baseURL        : process.env.PLATAFORMA_API,
      useAccessToken : true
    });
  }

  getAll({ page, perPage, search, ignorePagination, ids }) {
    const stringified = queryString.stringify({ page, perPage, search, ignorePagination, ids }, { skipNull: true, skipEmptyString: true });
    const params = stringified ? `?${stringified}` : '';
    return this.client.get(`academic/tags${params}`);
  }
}

export default new TagsService();
